import { Badge } from "@devhop/ui";
import {
  EXPENSE_STATUS_BADGE_VARIANTS,
  EXPENSE_STATUS_LABELS,
} from "../lib/expense-format";

export function ExpenseRecordStatusBadge({ status }: { status: string }) {
  return (
    <Badge variant={EXPENSE_STATUS_BADGE_VARIANTS[status] ?? "outline"}>
      {EXPENSE_STATUS_LABELS[status] ?? status}
    </Badge>
  );
}
